import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-03/lesson-22/task-02";

const task: Slide = {
  titleHtml:
    "Please look at the different settings, focus on the position of the source and the<br>amplitude of the loudspeaker. Mark the settings which make sense. The green bars<br>next to the speakers are representing the amplitude.",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
